import { useEffect } from "react";
import { useParams } from "react-router-dom";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { useTotemUpdate } from "../../../services/api-tansquery/totem/update";
import { useTotemDetails } from "../../../services/api-tansquery/totem/details";
import Form from "./form";

export default function FormUpdate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const { id } = useParams<{ id: string }>();
    const { data: totem } = useTotemDetails(Number(id));
    const mutation = useTotemUpdate(Number(id));

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Totem",
                    path: "/totens",
                    icon: DesktopWindows,
                },
                {
                    label: "Gerenciar",
                    path: "",
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Form
            action="update"
            totem={totem}
            mutation={mutation}
        />
    );
}
